module.exports = __webpack_public_path__ + "static/img/zhfk_11.2b4b269.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Images/zhfk_11.png
// module id = XR6Q
// module chunks = 1